export default {
  // header
  'develop': '개발자',
  'representative': '대표자',
  'resources': 'Maro 개발 리소스',
  'maroscan': '익스플로러',
  'menu': '메뉴',
  'close': '닫기',

  // footer
  'footer_home': '홈',
  'footer_about': '팀 소개',
  'footer_ecosystem': '에코시스템',
  'footer_developer': '개발자',
  'footer_media': 'Social media',
  'about_contant4_time1': 'In July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'In June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'In March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'In December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'In September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'In August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'In July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'In April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'In March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'In August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'In January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_txt': '안전하고 손쉽게 maro 블록체인 내 자산을 사용할 수 있는 모바일 월렛',
  'content1_download': '지금 다운로드',

  'content2_h3': 'MARO Connect는 사용자와 MARO를 이어주는 다리 역할을 합니다',
  'content2_p': 'MARO Connect를 통해 대표자 투표 참여, 보상 받기, 자산 전송, 결제 등을 할 수 있습니다',
  'content2_h5_1': '편리한 사용',
  'content2_txt_1': '손쉽게 계정을 생성해 MARO Connect를 사용하실 수 있습니다',
  'content2_h5_2': '높은 보안성',
  'content2_txt_2': '사용자가 사용하는 장비의 보안 기능 및 고성능 암호화 하드웨어를 통해 MARO를 안전하게 보관할 수 있습니다. 사용하던 장비를 분실했을 시, 니모닉 단어 및 개인키를 통해 기존 MARO Connect 계정을 새로운 장비에서 사용하실 수 있습니다',
  'content2_h5_3': '빠른 거래 속도',
  'content2_txt_3': 'Maro 블록체인은 빠른 거래 속도 및 자산 이체가 가능하며, 기타 블록체인에 존재하는 병목 현상 문제를 해결했습니다',

  'content3_h3': 'MARO Connect는 사용하기 쉽게 설계된 MARO 모바일 월렛입니다',
  'content3_p': 'MARO Connect는 사용하기 쉽게 설계된 MARO 모바일 월렛으로 토큰을 안전하게 보관할 수 있습니다. Maro 블록체인은 지속 가능한 토큰 이코노미 생태계와 인프라를 구축, 전세계 모두가 글로벌 경제와 연결되어 더 많은 기회를 얻을 수 있는 개방형 인프라를 제공합니다',
  'content3_link': '더 보기>'
}



// WEBPACK FOOTER //
// ./src/i18n/kr.js